/**
 * @description: 函数映射、参数解析中转站
 */

import dataFormatFn from '../dbDataFormat/dataFormat';
import dateTimeFormat from '../dbDataFormat/dateTimeFormat';

/**
 * @description: 数据格式化
 * @param {string} value 值
 * @param {string} formatRuleStr 数据格式化规则
 * @param {string} fillZeroStr 是否补0
 * @param {string} emptyValue 空值占位
 * @return {string}
 */
const dataFormat = (
  value: string,
  formatRuleStr: string,
  fillZeroStr: string,
  emptyValue: string,
) => {
  let formatRule;
  let fillZero;

  // 解析格式化规则：String / JSON Object
  try {
    formatRule = JSON.parse(formatRuleStr);
    // 非对象或数组类型，当string处理
    if (typeof formatRule !== 'object' || Array.isArray(formatRule)) {
      formatRule = formatRuleStr;
    }
  } catch (e) {
    // JSON解析错误，则直接当string
    formatRule = formatRuleStr;
  }

  // 解析转boolean值
  try {
    fillZero = fillZeroStr === undefined ? undefined : !!JSON.parse(fillZeroStr);
  } catch (e) {
    console.log('🚀 ~ dataFormat fillZeroStr error:', e);
  }

  return dataFormatFn({
    value,
    formatRule,
    fillZero,
    emptyValue,
  });
};

export default {
  dataFormat,
  dateTimeFormat
};
